import { Directive, OnInit, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Directive({
  selector: '[appFocusOnInit]',
  standalone: false
})
export class FocusOnInitDirective implements OnInit {
  constructor(private readonly _elementRef: ElementRef, private readonly _matDialog: MatDialog) {}

  ngOnInit() {
    if (this._matDialog.openDialogs && this._matDialog.openDialogs.length) {
      // Ne pas enlever le focus de la modale ouverte
      return;
    }

    const element = this._elementRef.nativeElement;
    if (element) {
      const scrollX =
        window.pageXOffset !== undefined
          ? window.pageXOffset
          : (document.documentElement || document.body.parentNode || document.body)['scrollLeft'];

      const scrollY =
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : (document.documentElement || document.body.parentNode || document.body)['scrollTop'];
      element.tabIndex = -1;
      element.style.outline = 'none';
      element.focus();
      window.scrollTo(scrollX, scrollY);
    }
  }
}
